<template>
  <div class="panel">
    <ElTabs v-model="activeTab">
      <ElTabs.TabPane name="province" :label="model.province ? model.province.districtName : '全国'">
        <div class="wrapper">
          <LeftSlider v-model:active-tab="activeTab" />
          <ProvincePanel ref="provincePanel" @select="handleSelectProvince" />
        </div>
      </ElTabs.TabPane>

      <ElTabs.TabPane name="city" :label="model.city ? model.city.districtName : '选择市'" v-if="model.province">
        <div class="wrapper">
          <LeftSlider v-model:active-tab="activeTab" />
          <CityPanel ref="cityPanel" :provinceDistrID="model.province.districtID" @select="handleSelectCity" />
        </div>
      </ElTabs.TabPane>
    </ElTabs>
    <div class="footer">
      <div> </div>
      <ElButton class="btn" @click="onReset" v-show="false">重置</ElButton>
      <div>
        <ElButton class="btn" @click="onCancel">取消</ElButton>
        <ElButton type="primary" class="btn" @click="onConfirm">确定</ElButton>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ElButton, ElTabs, ElMessage } from "element-plus"
import { ref, defineEmits, defineExpose } from "vue";
import { useAreaContext } from "../context";
import type { District } from "../../../api/types";

import LeftSlider from "./left-slider.vue";
import ProvincePanel from "./province-panel.vue";
import CityPanel from "./city-panel.vue";


const { model } = useAreaContext()!

const emit = defineEmits(['confirm', 'cancel'])

const activeTab = ref('province')
const provincePanel = ref()
const cityPanel = ref()

const handleSelectProvince = (value: District) => {
  activeTab.value = 'city'
  
  if (model.province?.districtID !== value.districtID) {
    model.city = undefined
  }
  model.province = value
}

const handleSelectCity = (value: District) => {
  model.city = value || {}
}

const onReset = () => {
  model.province.districtName = ''
  model.city.districtName = ''
}
const onConfirm = () => {
  if (!model.province) {
    return ElMessage.warning('请选择省市')
  }
  if (!model.city) {
    return ElMessage.warning('请选择城市')
  }
  emit('confirm')
}
const onCancel = () => {
  emit('cancel')
}

defineExpose({
  reset: () => {
    activeTab.value = 'province'
    provincePanel.value?.reset()
    cityPanel.value?.reset()
  }
})
</script>

<style>
.panel {
  display: flex;
  gap: 16px;
  flex-direction: column;
}
.panel .el-tabs__item.is-active, .el-tabs__item:hover {
  color: #7E51E4;
  font-weight: 600;
}
.panel .el-tabs__active-bar {
  background-color: #7E51E4;
}
.panel .el-tabs--bottom>.el-tabs__header .el-tabs__item:last-child, .el-tabs--top>.el-tabs__header .el-tabs__item:last-child {
  padding-left: 0;
}

.wrapper {
  padding-left: 96px;
  position: relative;
  min-height: 400px;
}

.footer {
  display: flex;
  gap: 12px;
  justify-content: space-between;
}
.footer .btn {
  width: 76px;
  height: 32px;
  &:first-child {
    background-color: #fff;
    border-color: #D9D9D9;
    color: #03050D;
    &:hover {
      background-color: #fff;
      color: #9B6FFF;
      border-color: #9B6FFF;
    }
  }
  &:last-child {
    margin-left: 10px;
    background-color: #7E51E4;
    border-color: #7E51E4;
    &:hover {
      background-color: #9B6FFF;
      border-color: #9B6FFF;
    }
  }
}
</style>